<div class="user-guide">
  <app-dialog-common dialogCommonTitle="USER_GUIDE.TITLE">
    <div class="content">
      <div class="user-guide__container">
        <img
          alt="user-guide"
          class="user-guide__container__video"
          [src]="helpGuidePicture"
        />

        <div>
          <div
            class="user-guide__container__description"
            [innerHTML]="'USER_GUIDE.DESCRIPTION' | translate"
          ></div>
          <qima-button
            [qimaButtonLabel]="'USER_GUIDE.DOWNLOAD_PDF' | translate"
            (qimaButtonClick)="onDownloadPdfClick()"
            [qimaButtonIconName]="qimaIcon.iconName.DOWNLOAD_PDF"
            [qimaButtonIconPosition]="qimaButton.buttonIconPosition.LEFT"
            [qimaButtonStyle]="qimaButton.buttonStyle.PRIMARY"
            [qimaButtonSize]="qimaButton.buttonSize.LARGE"
          ></qima-button>
        </div>
      </div>
      <img
        alt="plank"
        class="user-guide__plank"
        [src]="plankPicture"
      />
    </div>
  </app-dialog-common>
</div>
